import { toast } from "react-toastify";
import apiClient from "../../Config/apiConfig";
import { endpoints } from "../endpoints";

async function getGlobalData() {
  try {
    const response = await apiClient.get(`${endpoints.globalDataGet}`);

    return response.data;
  } catch (e) {
    console.log(e.message);
  }
}

async function getCMSData() {
  try {
    const response = await apiClient.get(`${endpoints.getAllCMS}`);
    return response.data;
  } catch (e) {
    console.log(e.message);
  }
}

async function getBannerData() {
  try {
    const response = await apiClient.get(`${endpoints.allBanner}`);
    return response.data;
  } catch (e) {
    console.log(e.message);
  }
}

async function getNoticeData() {
  try {
    const response = await apiClient.get(`${endpoints.noticeAll}`);
    return response.data;
  } catch (e) {
    console.log(e.message);
  }
}

async function getGalleryData() {
  try {
    const response = await apiClient.get(`${endpoints.allGallery}`);
    return response.data;
  } catch (e) {
    console.log(e.message);
  }
}
async function postRecruitment(data) {
  try {
    const responseSubmit = await apiClient.post(
      `${endpoints.recruitmentCreate}`,
      data
    );

    return responseSubmit.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
  }
}
async function postAdmission(data) {
  try {
    const responseSubmit = await apiClient.post(
      `${endpoints.createAdmission}`,
      data
    );
    return responseSubmit.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
    console.log(e.message);
  }
}
async function postContact(data) {
  try {
    const responseContact = await apiClient.post(
      `${endpoints.createContact}`,
      data
    );
    return responseContact.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
    console.log(e.message);
  }
}
async function getFee() {
  try {
    const response = await apiClient.get(endpoints.getAllFeeStructure);
    return response.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
    console.log(e.message);
  }
}

async function fetchSchool() {
  try {
    const response = await apiClient.get(endpoints.getAllSchool);
    return response?.data;
  } catch (e) {
    console.log(e.message);
  }
}

async function getPayment() {
  try {
    const response = await apiClient.get(endpoints.getAllFeeStructure);
    return response.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
    console.log(e.message);
  }
}

async function getStudentData(roll) {
  try {
    const response = await apiClient.get(
      `${endpoints.getStudentAllData}/${roll}`
    );
    return response.data;
  } catch (e) {
    toast.error(e?.response?.data?.msg);
    console.log(e.message);
  }
}
export {
  getStudentData,
  getNoticeData,
  getBannerData,
  getCMSData,
  getGlobalData,
  getGalleryData,
  postRecruitment,
  postAdmission,
  postContact,
  getFee,
  fetchSchool,
  getPayment,
};
